module.exports = __webpack_public_path__ + "static/media/completed-selected.ca6fa2d3.png";